module.exports = __webpack_public_path__ + "img/ua.9a8f121d.svg";